import { auth, db } from "@/api/firebase";
import axios from "axios";

export default class HttpsHelper {
  static async getHistoryGameShallow(): Promise<any> {
    try {
      const data = await axios
        .create({
          baseURL: db.ref().toString(),
          headers: { "Content-type": "application.json" },
        })
        .get(
          "leaderboards.json?shallow=true&auth=" +
            (await auth.currentUser?.getIdToken())
        );
      return data.data;
    } catch (error) {
      console.log(error);
      return "";
    }
  }
}
